import { FilterOption } from "../Filter/Filter";

export const LimitOptions: Array<FilterOption & { limit: number }> = [
  { id: 0, label: "All", limit: 0 },
  { id: 1, label: "10", limit: 10 },
  { id: 2, label: "20", limit: 20 },
  { id: 3, label: "25", limit: 25 },
  { id: 4, label: "30", limit: 30 },
  { id: 5, label: "50", limit: 50 },
  { id: 6, label: "100", limit: 100 },
  { id: 7, label: "200", limit: 200 },
  { id: 8, label: "500", limit: 500 },
  { id: 9, label: "1K", limit: 1000 },
  { id: 10, label: "2K", limit: 2000 },
];
